angular.module('hcap-analytics')
  .factory('Util', [
    '$state',
    'AssessmentService',
    'UserService',
  function(
    $state,
    AssessmentService,
    UserService,
  ) {
    const ignorable = [
      'page_break',
      'caption',
      'caption_minor',
      'team_effective_header',
      'team_table_contrib',
      'team_table_interact',
      'team_table_track',
      'team_table_quality',
      'team_table_knowledge',
    ];

    const noPrompt = [
      'page_break',
      'team_effective_header',
      'team_table_contrib',
      'team_table_interact',
      'team_table_track',
      'team_table_quality',
      'team_table_knowledge',
    ];

    return {
      assessmentOrdinal(assessment, participant, orderedAssessments = []) {
        const seriesIndex = participant?.assessmentSeriesIndex ?? participant?.seriesIndex ?? assessment?.seriesIndex;

        if (participant?.bundleGuid && _.isNumber(seriesIndex) && seriesIndex >= 0) {
          return seriesIndex + 1;
        }

        if (_.isNumber(seriesIndex) && seriesIndex > 0) {
          return seriesIndex;
        }

        if (assessment?.guid && Array.isArray(orderedAssessments) && orderedAssessments.length > 0) {
          const orderedIndex = orderedAssessments.findIndex(item => {
            return item.assessmentId === assessment.guid || item.guid === assessment.guid;
          });

          if (orderedIndex !== -1) {
            return orderedIndex + 1;
          }
        }

        return null;
      },
      assessmentDisplayName(assessment, participant, orderedAssessments = []) {
        const ordinal = this.assessmentOrdinal(assessment, participant, orderedAssessments);

        if (ordinal) {
          return `Assessment ${ordinal}`;
        }

        return assessment?.name || null;
      },
      groupDesignatedAssessments(assessments = []) {
        const singles = [];
        const bundleGroups = {};

        assessments.forEach(assessment => {
          const participant = assessment?.participant || {};
          const cohortId = participant?.cohortId?.toString?.() || participant?.cohortId || null;

          if (!participant.designatedRater || !cohortId) {
            singles.push({
              ...assessment,
              displayName: assessment.name,
              inviteType: 'single',
            });
            return;
          }

          const key = `${cohortId}:${(participant.designatorEmail || '').toLowerCase()}:${(participant.email || '').toLowerCase()}`;
          if (!bundleGroups[key]) {
            bundleGroups[key] = {
              ...assessment,
              displayName: '360 Feedback Assessments',
              inviteType: 'bundle',
              bundleParticipantId: participant.guid,
              groupedAssessments: [],
            };
          }

          bundleGroups[key].groupedAssessments.push(assessment);
        });

        return [
          ...singles,
          ...Object.values(bundleGroups).map(group => ({
            ...group,
            groupedAssessments: _.sortBy(group.groupedAssessments, assessment => {
              return this.assessmentOrdinal(assessment, assessment.participant) || Number.MAX_SAFE_INTEGER;
            }),
          })),
        ];
      },
      phaseDisplay(index, phases, short) {
        const type = phases[index].type;

        const text = short ? {
          setup: 'Charter & Skills',
          prep: 'Teamwork Prep',
          prog: 'Health Report',
          eval: 'Evaluations',
        } : {
          setup: 'Charter and Skills Inventory',
          prep: 'Preparing for Teamwork',
          prog: 'Team Health Report',
          eval: 'Project Milestone Evaluation',
        };

        if (!['prog', 'eval'].includes(type)) {
          return text[type];
        } else {
          let count = 0;

          for (let i = 0; i < phases.length; i++) {
            if (phases[i].type === type) {
              ++count;

              if (i === index) {
                return text[type] + ' ' + count;
              }
            }
          }
        }
      },
      canIgnore(q) {
        return ignorable.includes(q.type);
      },
      hideKeyBox(q) {
        return ignorable.includes(q.type);
      },
      hidePromptBox(q) {
        return noPrompt.includes(q.type);
      },
      async viewAssessmentState(assessmentGuid, templateId, participant = null, params = {}, cohortId = null) {
        const portal = $state.params.portal || 'v2';

        if (participant?.completed) {
          return {
            state: 'participate.result',
            params: {
              portal,
              ...params,
              templateId,
              participantId: participant.guid,
            },
            options: { inherit: false },
          };
        } else {
          if (!participant) {
            const user = UserService.getUser();
            return new Promise((res, reject) => {
              AssessmentService.addParticipant(assessmentGuid, {
                email: user.email,
                ...(cohortId ? { cohortId } : {}),
              }, false, resData => {
                res({
                  state: 'participate.questions',
                  params: {
                    portal,
                    ...params,
                    templateId,
                    participantId: resData.participant.guid,
                  },
                  options: { inherit: false, }
                });
              });
            });
          } else {
            return {
              state: 'participate.questions',
              params: {
                portal,
                ...params,
                templateId,
                participantId: participant.guid,
              },
              options: { inherit: false, }
            };
          }
        }
      },
      async viewAssessment(assessmentGuid, templateId, participant, cohortId = null) {
        const state = await this.viewAssessmentState(assessmentGuid, templateId, participant, {}, cohortId);
        $state.go(state.state, state.params, state.options);
      },
      parseSheet(workbook) {
        const result = {};
        workbook.SheetNames.forEach(function(sheetName) {
          const roa = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);

          if (roa.length > 0) {
            result[sheetName] = roa;
          }
        });

        return result;
      },
    };
  },
]);
